import React from "react";
import ReactDOM from "react-dom/client";
import { StyledEngineProvider } from "@mui/material/styles";
import { SnackbarProvider } from "notistack";
import App from "./App";
import { AppProvider } from "./Helpers/Contexts/AppContext";

if (process.env.NODE_ENV === "development") {
  try {
    const { scan } = require("react-scan");
    scan({ enabled: true });
  } catch (e) {
    console.warn("React Scan não pôde ser inicializado:", e);
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
      <AppProvider>
        {/* 5s fixos: sem a pausa quando a janela perde o foco, que deixava o balão na tela indefinidamente */}
        <SnackbarProvider autoHideDuration={5000} disableWindowBlurListener>
          <App />
        </SnackbarProvider>
      </AppProvider>
    </StyledEngineProvider>
  </React.StrictMode>
);
